/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/ 		var executeModules = data[2];
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 		// add entry modules from loaded chunk to deferred list
/******/ 		deferredModules.push.apply(deferredModules, executeModules || []);
/******/
/******/ 		// run deferred modules when all chunks ready
/******/ 		return checkDeferredModules();
/******/ 	};
/******/ 	function checkDeferredModules() {
/******/ 		var result;
/******/ 		for(var i = 0; i < deferredModules.length; i++) {
/******/ 			var deferredModule = deferredModules[i];
/******/ 			var fulfilled = true;
/******/ 			for(var j = 1; j < deferredModule.length; j++) {
/******/ 				var depId = deferredModule[j];
/******/ 				if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 			}
/******/ 			if(fulfilled) {
/******/ 				deferredModules.splice(i--, 1);
/******/ 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 			}
/******/ 		}
/******/
/******/ 		return result;
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		16: 0
/******/ 	};
/******/
/******/ 	var deferredModules = [];
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	var jsonpArray = window["loftWebpackJsonp"] = window["loftWebpackJsonp"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// add entry module to deferred list
/******/ 	deferredModules.push([60,0]);
/******/ 	// run deferred modules when ready
/******/ 	return checkDeferredModules();
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * fitty v2.3.3 - Snugly resizes text to fit its parent container
 * Copyright (c) 2020 Rik Schennink <rik@pqina.nl> (https://pqina.nl/)
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports["default"] = function (w) {
  // no window, early exit
  if (!w) return; // node list to array helper method

  var toArray = function toArray(nl) {
    return [].slice.call(nl);
  }; // states


  var DrawState = {
    IDLE: 0,
    DIRTY_CONTENT: 1,
    DIRTY_LAYOUT: 2,
    DIRTY: 3
  }; // all active fitty elements

  var fitties = []; // group all redraw calls till next frame, we cancel each frame request when a new one comes in. If no support for request animation frame, this is an empty function and supports for fitty stops.

  var redrawFrame = null;
  var requestRedraw = 'requestAnimationFrame' in w ? function () {
    w.cancelAnimationFrame(redrawFrame);
    redrawFrame = w.requestAnimationFrame(function () {
      return redraw(fitties.filter(function (f) {
        return f.dirty && f.active;
      }));
    });
  } : function () {}; // sets all fitties to dirty so they are redrawn on the next redraw loop, then calls redraw

  var redrawAll = function redrawAll(type) {
    return function () {
      fitties.forEach(function (f) {
        return f.dirty = type;
      });
      requestRedraw();
    };
  }; // redraws fitties so they nicely fit their parent container


  var redraw = function redraw(fitties) {
    // getting info from the DOM at this point should not trigger a reflow, let's gather as much intel as possible before triggering a reflow
    // check if styles of all fitties have been computed
    fitties.filter(function (f) {
      return !f.styleComputed;
    }).forEach(function (f) {
      f.styleComputed = computeStyle(f);
    }); // restyle elements that require pre-styling, this triggers a reflow, please try to prevent by adding CSS rules (see docs)

    fitties.filter(shouldPreStyle).forEach(applyStyle); // we now determine which fitties should be redrawn

    var fittiesToRedraw = fitties.filter(shouldRedraw); // we calculate final styles for these fitties

    fittiesToRedraw.forEach(calculateStyles); // now we apply the calculated styles from our previous loop

    fittiesToRedraw.forEach(function (f) {
      applyStyle(f);
      markAsClean(f);
    }); // now we dispatch events for all restyled fitties

    fittiesToRedraw.forEach(dispatchFitEvent);
  };

  var markAsClean = function markAsClean(f) {
    return f.dirty = DrawState.IDLE;
  };

  var calculateStyles = function calculateStyles(f) {
    // get available width from parent node
    f.availableWidth = f.element.parentNode.clientWidth; // the space our target element uses

    f.currentWidth = f.element.scrollWidth; // remember current font size

    f.previousFontSize = f.currentFontSize; // let's calculate the new font size

    f.currentFontSize = Math.min(Math.max(f.minSize, f.availableWidth / f.currentWidth * f.previousFontSize), f.maxSize); // if allows wrapping, only wrap when at minimum font size (otherwise would break container)

    f.whiteSpace = f.multiLine && f.currentFontSize === f.minSize ? 'normal' : 'nowrap';
  }; // should always redraw if is not dirty layout, if is dirty layout, only redraw if size has changed


  var shouldRedraw = function shouldRedraw(f) {
    return f.dirty !== DrawState.DIRTY_LAYOUT || f.dirty === DrawState.DIRTY_LAYOUT && f.element.parentNode.clientWidth !== f.availableWidth;
  }; // every fitty element is tested for invalid styles


  var computeStyle = function computeStyle(f) {
    // get style properties
    var style = w.getComputedStyle(f.element, null); // get current font size in pixels (if we already calculated it, use the calculated version)

    f.currentFontSize = parseFloat(style.getPropertyValue('font-size')); // get display type and wrap mode

    f.display = style.getPropertyValue('display');
    f.whiteSpace = style.getPropertyValue('white-space');
  }; // determines if this fitty requires initial styling, can be prevented by applying correct styles through CSS


  var shouldPreStyle = function shouldPreStyle(f) {
    var preStyle = false; // if we already tested for prestyling we don't have to do it again

    if (f.preStyleTestCompleted) return false; // should have an inline style, if not, apply

    if (!/inline-/.test(f.display)) {
      preStyle = true;
      f.display = 'inline-block';
    } // to correctly calculate dimensions the element should have whiteSpace set to nowrap


    if (f.whiteSpace !== 'nowrap') {
      preStyle = true;
      f.whiteSpace = 'nowrap';
    } // we don't have to do this twice


    f.preStyleTestCompleted = true;
    return preStyle;
  }; // apply styles to single fitty


  var applyStyle = function applyStyle(f) {
    f.element.style.whiteSpace = f.whiteSpace;
    f.element.style.display = f.display;
    f.element.style.fontSize = f.currentFontSize + 'px';
  }; // dispatch a fit event on a fitty


  var dispatchFitEvent = function dispatchFitEvent(f) {
    f.element.dispatchEvent(new CustomEvent('fit', {
      detail: {
        oldValue: f.previousFontSize,
        newValue: f.currentFontSize,
        scaleFactor: f.currentFontSize / f.previousFontSize
      }
    }));
  }; // fit method, marks the fitty as dirty and requests a redraw (this will also redraw any other fitty marked as dirty)


  var fit = function fit(f, type) {
    return function () {
      f.dirty = type;
      if (!f.active) return;
      requestRedraw();
    };
  };

  var init = function init(f) {
    // save some of the original CSS properties before we change them
    f.originalStyle = {
      whiteSpace: f.element.style.whiteSpace,
      display: f.element.style.display,
      fontSize: f.element.style.fontSize
    }; // should we observe DOM mutations

    observeMutations(f); // this is a new fitty so we need to validate if it's styles are in order

    f.newbie = true; // because it's a new fitty it should also be dirty, we want it to redraw on the first loop

    f.dirty = true; // we want to be able to update this fitty

    fitties.push(f);
  };

  var destroy = function destroy(f) {
    return function () {
      // remove from fitties array
      fitties = fitties.filter(function (_) {
        return _.element !== f.element;
      }); // stop observing DOM

      if (f.observeMutations) f.observer.disconnect(); // reset the CSS properties we changes

      f.element.style.whiteSpace = f.originalStyle.whiteSpace;
      f.element.style.display = f.originalStyle.display;
      f.element.style.fontSize = f.originalStyle.fontSize;
    };
  }; // add a new fitty, does not redraw said fitty


  var subscribe = function subscribe(f) {
    return function () {
      if (f.active) return;
      f.active = true;
      requestRedraw();
    };
  }; // remove an existing fitty


  var unsubscribe = function unsubscribe(f) {
    return function () {
      return f.active = false;
    };
  };

  var observeMutations = function observeMutations(f) {
    // no observing?
    if (!f.observeMutations) return; // start observing mutations

    f.observer = new MutationObserver(fit(f, DrawState.DIRTY_CONTENT)); // start observing

    f.observer.observe(f.element, f.observeMutations);
  }; // default mutation observer settings


  var mutationObserverDefaultSetting = {
    subtree: true,
    childList: true,
    characterData: true
  }; // default fitty options

  var defaultOptions = {
    minSize: 16,
    maxSize: 512,
    multiLine: true,
    observeMutations: 'MutationObserver' in w ? mutationObserverDefaultSetting : false
  }; // array of elements in, fitty instances out

  function fittyCreate(elements, options) {
    // set options object
    var fittyOptions = _extends({}, defaultOptions, options); // create fitties


    var publicFitties = elements.map(function (element) {
      // create fitty instance
      var f = _extends({}, fittyOptions, {
        // internal options for this fitty
        element: element,
        active: true
      }); // initialise this fitty


      init(f); // expose API

      return {
        element: element,
        fit: fit(f, DrawState.DIRTY),
        unfreeze: subscribe(f),
        freeze: unsubscribe(f),
        unsubscribe: destroy(f)
      };
    }); // call redraw on newly initiated fitties

    requestRedraw(); // expose fitties

    return publicFitties;
  } // fitty creation function


  function fitty(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}; // if target is a string

    return typeof target === 'string' ? // treat it as a querySelector
    fittyCreate(toArray(document.querySelectorAll(target)), options) : // create single fitty
    fittyCreate([target], options)[0];
  } // handles viewport changes, redraws all fitties, but only does so after a timeout


  var resizeDebounce = null;

  var onWindowResized = function onWindowResized() {
    w.clearTimeout(resizeDebounce);
    resizeDebounce = w.setTimeout(redrawAll(DrawState.DIRTY_LAYOUT), fitty.observeWindowDelay);
  }; // define observe window property, so when we set it to true or false events are automatically added and removed


  var events = ['resize', 'orientationchange'];
  Object.defineProperty(fitty, 'observeWindow', {
    set: function set(enabled) {
      var method = (enabled ? 'add' : 'remove') + 'EventListener';
      events.forEach(function (e) {
        w[method](e, onWindowResized);
      });
    }
  }); // fitty global properties (by setting observeWindow to true the events above get added)

  fitty.observeWindow = true;
  fitty.observeWindowDelay = 100; // public fit all method, will force redraw no matter what

  fitty.fitAll = redrawAll(DrawState.DIRTY); // export our fitty function, we don't want to keep it to our selves

  return fitty;
}(typeof window === 'undefined' ? null : window);

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

/* Do not delete - Used for Webpack */

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "jQuery"
var external_jQuery_ = __webpack_require__(0);
var external_jQuery_default = /*#__PURE__*/__webpack_require__.n(external_jQuery_);

// EXTERNAL MODULE: ./src/scripts/vendors/global/events.js
var events = __webpack_require__(1);
var events_default = /*#__PURE__*/__webpack_require__.n(events);

// EXTERNAL MODULE: ./src/scripts/vendors/global/fitty.js
var fitty = __webpack_require__(14);
var fitty_default = /*#__PURE__*/__webpack_require__.n(fitty);

// EXTERNAL MODULE: ./src/scripts/vendors/sections/flickity.js
var flickity = __webpack_require__(2);
var flickity_default = /*#__PURE__*/__webpack_require__.n(flickity);

// EXTERNAL MODULE: ./node_modules/micromodal/dist/micromodal.es.js
var micromodal_es = __webpack_require__(5);

// EXTERNAL MODULE: ./src/scripts/features/global-video.js
var global_video = __webpack_require__(7);

// EXTERNAL MODULE: ./src/scripts/templates/product-section.js + 2 modules
var product_section = __webpack_require__(10);

// EXTERNAL MODULE: ./src/scripts/cart/cart.js + 2 modules
var cart = __webpack_require__(12);

// EXTERNAL MODULE: ./src/scripts/cart/events.js
var cart_events = __webpack_require__(3);

// CONCATENATED MODULE: ./src/scripts/legacy/theme.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


window.jQuery = external_jQuery_default.a;

var Modernizr = __webpack_require__(23);




 // import { formatMoney } from '../utilities/currency.js';


var LoftSiteVideo = Object(global_video["a" /* default */])(); // import { quantityUtilities } from '../utilities/quantity.js';

 // import { productVariants } from '../templates/product-variants.js';
// import { productPage } from '../templates/product-page.js';



/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */

(function (a) {
  a.fn.prepareTransition = function () {
    return this.each(function () {
      var b = a(this);
      b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {
        b.removeClass("is-transitioning");
      });
      var c = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"];
      var d = 0;
      a.each(c, function (a, c) {
        d = parseFloat(b.css(c)) || d;
      });

      if (d != 0) {
        b.addClass("is-transitioning");
        b[0].offsetWidth;
      }
    });
  };
})(jQuery);
/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */


function replaceUrlParam(e, r, a) {
  var n = new RegExp("(" + r + "=).*?(&|$)"),
      c = e;
  return c = e.search(n) >= 0 ? e.replace(n, "$1" + a + "$2") : c + (c.indexOf("?") > 0 ? "&" : "?") + r + "=" + a;
}

;
/*jshint browser:true */

/*!
* FitVids 1.1
*
* Copyright 2013, Chris Coyier - http://css-tricks.com + Dave Rupert - http://daverupert.com
* Credit to Thierry Koblentz - http://www.alistapart.com/articles/creating-intrinsic-ratios-for-video/
* Released under the WTFPL license - http://sam.zoy.org/wtfpl/
*
*/

!function (t) {
  "use strict";

  t.fn.fitVids = function (e) {
    var i = {
      customSelector: null,
      ignore: null
    };

    if (!document.getElementById("fit-vids-style")) {
      var r = document.head || document.getElementsByTagName("head")[0],
          a = document.createElement("div");
      a.innerHTML = '<p>x</p><style id="fit-vids-style">.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}</style>', r.appendChild(a.childNodes[1]);
    }

    return e && t.extend(i, e), this.each(function () {
      var e = ['iframe[src*="player.vimeo.com"]', 'iframe[src*="youtube.com"]', 'iframe[src*="youtube-nocookie.com"]', 'iframe[src*="kickstarter.com"][src*="video.html"]', "object", "embed"];
      i.customSelector && e.push(i.customSelector);
      var r = ".fitvidsignore";
      i.ignore && (r = r + ", " + i.ignore);
      var a = t(this).find(e.join(","));
      (a = (a = a.not("object object")).not(r)).each(function () {
        var e = t(this);

        if (!(e.parents(r).length > 0 || "embed" === this.tagName.toLowerCase() && e.parent("object").length || e.parent(".fluid-width-video-wrapper").length)) {
          e.css("height") || e.css("width") || !isNaN(e.attr("height")) && !isNaN(e.attr("width")) || (e.attr("height", 9), e.attr("width", 16));
          var i = ("object" === this.tagName.toLowerCase() || e.attr("height") && !isNaN(parseInt(e.attr("height"), 10)) ? parseInt(e.attr("height"), 10) : e.height()) / (isNaN(parseInt(e.attr("width"), 10)) ? e.width() : parseInt(e.attr("width"), 10));

          if (!e.attr("name")) {
            var a = "fitvid" + t.fn.fitVids._count;
            e.attr("name", a), t.fn.fitVids._count++;
          }

          e.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top", 100 * i + "%"), e.removeAttr("height").removeAttr("width");
        }
      });
    });
  }, t.fn.fitVids._count = 0;
}(window.jQuery || window.Zepto);
/*!
 * Check if an element is out of the viewport
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}  elem The element to check
 * @return {Object}     A set of booleans for each side of the element
 */

var isOutOfViewport = function isOutOfViewport(elem) {
  // Get element's bounding
  var bounding = elem.getBoundingClientRect(); // Check if it's out of the viewport on each side

  var out = {};
  out.top = bounding.top < 0;
  out.left = bounding.left < 0;
  out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
  out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
  out.any = out.top || out.left || out.bottom || out.right;
  out.all = out.top && out.left && out.bottom && out.right;
  return out;
};
/*!
 * Get all direct descendant elements that match a test condition
 * (c) 2021 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   elem     The element to get direct descendants for
 * @param  {Function} callback The test condition
 * @return {Array}           The matching direct descendants
 */


function childrenMatches(elem, callback) {
  return Array.from(elem.children).filter(callback);
} // Theme ID


window.themeInfo = {
  name: "Loft"
};
window.themeData = {
  name: "Loft",
  version: "2.3.5",
  jQuery: "" + external_jQuery_default.a.fn.jquery + "",
  settings: {}
};
var videoPlayer = [];

if (typeof Shopify === 'undefined') {
  Shopify = {};
} // Timber functions


window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: external_jQuery_default()('html'),
    $body: external_jQuery_default()(document.body),
    // Navigation
    $navigation: external_jQuery_default()('#AccessibleNav'),
    $mobileSubNavToggle: external_jQuery_default()('.mobile-nav__toggle'),
    // Collection Pages
    $changeView: external_jQuery_default()('.change-view'),
    // Product Page
    $productImage: external_jQuery_default()('#ProductPhotoImg'),
    $thumbImages: external_jQuery_default()('#ProductThumbs').find('a.product-single__thumbnail'),
    // Customer Pages
    $recoverPasswordLink: external_jQuery_default()('#RecoverPassword'),
    $hideRecoverPasswordLink: external_jQuery_default()('#HideRecoverPasswordLink'),
    $recoverPasswordForm: external_jQuery_default()('#RecoverPasswordForm'),
    $customerLoginForm: external_jQuery_default()('#CustomerLoginForm'),
    $passwordResetSuccess: external_jQuery_default()('#ResetSuccess')
  };
};

timber.init = function () {
  timber.cacheSelectors();
  timber.drawersInit();
  timber.responsiveVideos();
  timber.loginForms();
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
};

timber.getHash = function () {
  return window.location.hash;
};

timber.responsiveVideos = function () {
  var $iframeVideo = external_jQuery_default()('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    external_jQuery_default()(this).wrap('<div class="video-wrapper"></div>');
  });
  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.loginForms = function () {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function (evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });
  timber.cache.$hideRecoverPasswordLink.on('click', function (evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  }); // Allow deep linking to recover password form

  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function () {
  timber.cache.$passwordResetSuccess.show();
};
/*============================================================================
Drawer modules
- Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/


timber.Drawers = function () {
  var Drawer = function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-bottom'
    };
    this.$nodes = {
      parent: external_jQuery_default()('body, html'),
      page: external_jQuery_default()('#PageContainer'),
      moved: external_jQuery_default()('.is-moved-by-drawer')
    };
    this.config = external_jQuery_default.a.extend(defaults, options);
    this.position = position;
    this.$drawer = external_jQuery_default()('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = external_jQuery_default()('html').hasClass('js-drawer-open'); //this.drawerIsOpen = false;

    this.init();
  };

  Drawer.prototype.init = function () {
    //Clear events just in case this is a re-init
    external_jQuery_default()('.js-drawer-open-left').off('click');
    this.$drawer.find(this.config.close).off('click'); //Set the events

    external_jQuery_default()('.js-drawer-open-left').on('click', external_jQuery_default.a.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', external_jQuery_default.a.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false; // Prevent following href if link is clicked

    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    } // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.


    if (evt && evt.stopPropagation) {
      evt.stopPropagation(); // save the source of the click, we'll focus to this on close

      this.$activeSource = external_jQuery_default()(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    } // Notify the drawer is going to open


    timber.cache.$body.trigger('beforeDrawerOpen.timber', this); // Run function when draw opens if set

    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    } // Lock scrolling on mobile


    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });
    this.$nodes.page.on('click.drawer', external_jQuery_default.a.proxy(function () {
      this.close();
      return false;
    }, this)); // Set focus on drawer

    this.trapFocus(this.$drawer, 'drawer_focus'); // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation

    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();
    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    function resizeGroup() {
      var newCalc = external_jQuery_default()('#NavDrawer').outerHeight() - (external_jQuery_default()('.drawer__header').outerHeight() + external_jQuery_default()('.mobile__nav-social-media').innerHeight()) - 55;
      external_jQuery_default()(".mobile-nav__link-group").css("height", newCalc);
    }

    setTimeout(function () {
      resizeGroup();
    }, 600);
    var lastWidth = external_jQuery_default()(window).width();
    external_jQuery_default()(window).on("resize", function () {
      if (external_jQuery_default()(window).width() != lastWidth) {
        lastWidth = external_jQuery_default()(window).width();
        resizeGroup();
      }
    }); // Notify the drawer has opened

    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    } // Notify the drawer is going to close


    timber.cache.$body.trigger('beforeDrawerClose.timber', this); // deselect any focused form elements

    external_jQuery_default()(document.activeElement).trigger('blur'); // Ensure closing transition is applied to moved elements, like the nav

    this.$nodes.moved.prepareTransition({
      disableExisting: true
    });
    this.$drawer.prepareTransition({
      disableExisting: true
    });
    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);
    this.drawerIsOpen = false; // Remove focus on drawer

    this.removeTrapFocus(this.$drawer, 'drawer_focus');
    this.$nodes.page.off('.drawer'); // Notify the drawer is closed now

    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
    $container.attr('tabindex', '-1');
    $container.focus();
    external_jQuery_default()(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
    $container.removeAttr('tabindex');
    external_jQuery_default()(document).off(eventName);
  };

  return Drawer;
}(); // Initialize Timber's JS on docready


external_jQuery_default()(timber.init);
var theme = window.theme || theme || {};

theme.Helpers = function () {
  var touchDevice = false;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch
  };
}();

theme.Disclosure = function () {
  var selectors = {
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]',
    disclosureSection: '.disclosure-section'
  };
  var classes = {
    listVisible: 'disclosure-list--visible',
    layerTop: 'disclosure-section--zIndex'
  };

  function Disclosure($disclosure) {
    this.$container = $disclosure;
    this.cache = {};

    this._cacheSelectors();

    this._connectOptions();

    this._connectToggle();

    this._onFocusOut();
  }

  Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
    _cacheSelectors: function _cacheSelectors() {
      this.cache = {
        $disclosureList: this.$container.find(selectors.disclosureList),
        $disclosureToggle: this.$container.find(selectors.disclosureToggle),
        $disclosureInput: this.$container.find(selectors.disclosureInput),
        $disclosureOptions: this.$container.find(selectors.disclosureOptions),
        $disclosureSection: external_jQuery_default()(selectors.disclosureSection)
      };
    },
    _connectToggle: function _connectToggle() {
      this.cache.$disclosureToggle.on('click', function (evt) {
        var ariaExpanded = external_jQuery_default()(evt.currentTarget).attr('aria-expanded') === 'true';
        external_jQuery_default()(evt.currentTarget).attr('aria-expanded', !ariaExpanded);
        this.cache.$disclosureList.toggleClass(classes.listVisible);
        this.cache.$disclosureSection.toggleClass(classes.layerTop);
      }.bind(this));
    },
    _connectOptions: function _connectOptions() {
      this.cache.$disclosureOptions.on('click', function (evt) {
        this._submitForm(external_jQuery_default()(evt.currentTarget).data('value'));
      }.bind(this));
    },
    _onFocusOut: function _onFocusOut() {
      this.cache.$disclosureToggle.on('focusout', function (evt) {
        var disclosureLostFocus = this.$container.has(evt.relatedTarget).length === 0;

        if (disclosureLostFocus) {
          this._hideList();
        }
      }.bind(this));
      this.cache.$disclosureList.on('focusout', function (evt) {
        var childInFocus = external_jQuery_default()(evt.currentTarget).has(evt.relatedTarget).length > 0;
        var isVisible = this.cache.$disclosureList.hasClass(classes.listVisible);

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      }.bind(this));
      this.$container.on('keyup', function (evt) {
        if (evt.which !== slate.utils.keyboardKeys.ESCAPE) return;

        this._hideList();

        this.cache.$disclosureToggle.focus();
      }.bind(this));

      this.bodyOnClick = function (evt) {
        var isOption = this.$container.has(evt.target).length > 0;
        var isVisible = this.cache.$disclosureList.hasClass(classes.listVisible);

        if (isVisible && !isOption) {
          this._hideList();
        }
      }.bind(this);

      external_jQuery_default()('body').on('click', this.bodyOnClick);
    },
    _submitForm: function _submitForm(value) {
      this.cache.$disclosureInput.val(value);
      this.$container.parents('form').submit();
    },
    _hideList: function _hideList() {
      this.cache.$disclosureList.removeClass(classes.listVisible);
      this.cache.$disclosureSection.removeClass(classes.layerTop);
      this.cache.$disclosureToggle.attr('aria-expanded', false);
    },
    unload: function unload() {
      external_jQuery_default()('body').off('click', this.bodyOnClick);
      this.cache.$disclosureOptions.off();
      this.cache.$disclosureToggle.off();
      this.cache.$disclosureList.off();
      this.$container.off();
    }
  });
  return Disclosure;
}();
/*
theme.Site

Initializes and provides site-wide functionality.
*/


theme.Site = function () {
  return {
    /***** Public Methods *****/

    /*
        =function init()
        Initializes all site-wide functionality.
    */
    init: function init() {
      this._initPlugins();

      this._initScrollFixed();

      this._extendjQuery();
    },

    /***** Private Methods *****/

    /*
        =function _initPlugins()
        Initializes the plugins used site-wide.
    */
    _initPlugins: function _initPlugins() {
      var animations_active = theme.settings.enable_animations;

      if (animations_active === 'false' || animations_active === undefined) {
        return;
      } // get your elements, by class name '.js-item'  


      var intersectionObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var childElements = entry.target.querySelectorAll('div');
            childElements.forEach(function (item) {
              if (item.style.backgroundImage !== '' || item.hasAttribute('data-bgset')) {
                item.classList.add('section__load-animations--fade');
              }
            });
            var leftRevealAnimationElements = entry.target.querySelectorAll(".section__image-animations--left-reveal");

            if (leftRevealAnimationElements.length > 0) {
              leftRevealAnimationElements.forEach(function (elem) {
                // elem.classList.add("animate__animated", "animate__fadeInLeft");
                elem.classList.remove("section__image-animations--left-reveal");
              });
            }

            external_jQuery_default.a.each(external_jQuery_default()(entry.target).find('div'), function (i, elem) {
              if (elem.style.backgroundImage !== '') {
                if (elem.classList.contains('section__image-animations--scale')) {
                  elem.classList.add('section__load-animations--scale');
                  elem.classList.remove('section__load-animations--fade');
                } else {
                  if (elem.classList.contains('plyr__poster') == false) {
                    elem.classList.add('section__load-animations--fade');
                  }
                }
              }
            }); // Init scale / fade Animation on img

            if (external_jQuery_default()(entry.target).find('img').length > 0) {
              external_jQuery_default.a.each(external_jQuery_default()(entry.target).find('img'), function (i, elem) {
                if (elem.classList.contains('section__image-animations--scale')) {
                  elem.classList.add('section__load-animations--scale');
                  elem.classList.remove('section__load-animations--fade');
                } else {
                  elem.classList.add('section__load-animations--fade');
                }
              });
            } // it's good to remove observer,
            // if you don't need it any more


            observer.unobserve(entry.target);
          }
        });
      });

      var elements = _toConsumableArray(document.querySelectorAll('.shopify-section')); // start observing your elements


      elements.forEach(function (element) {
        return intersectionObserver.observe(element);
      });
    },

    /*
        =function _initScrollFixed()
        Initializes scrolling fix.
    */
    _initScrollFixed: function _initScrollFixed() {
      var scrollFixedSelector = '.scroll_fixed';

      if (external_jQuery_default()(scrollFixedSelector).offset()) {
        var leftInit = external_jQuery_default()(scrollFixedSelector).offset().left,
            top = external_jQuery_default()(scrollFixedSelector).offset().top - parseFloat(external_jQuery_default()(scrollFixedSelector).css('margin-top').replace(/auto/, 0));
        external_jQuery_default()(window).scroll(function (event) {
          var x = 0 - external_jQuery_default()(this).scrollLeft();
          var y = external_jQuery_default()(this).scrollTop(); // whether that's below the form

          if (y >= top) {
            // if so, ad the fixed class
            external_jQuery_default()(scrollFixedSelector).addClass('fixed');
          } else {
            // otherwise remove it
            external_jQuery_default()(scrollFixedSelector).removeClass('fixed');
          }

          external_jQuery_default()(this.selectors.scrollFixed).offset({
            left: x + leftInit
          });
        });
      }
    },

    /*
        =function _extendjQuery()
        Extends the jQuery object with custom functions to
        give additional functionality.
    */
    _extendjQuery: function _extendjQuery() {
      external_jQuery_default.a.fn.extend({
        /* 
            =function mySection()
            Returns the section's container that the calling element
            is in.
        */
        mySection: function mySection() {
          return this.closest('[data-section-id]');
        }
      });
    },
    _initVideo: function _initVideo() {
      // YouTube Player API for header BG video
      if (window.YT && window.YT.loaded) {
        if (external_jQuery_default()('[data-youtube]').length > -1) {
          setupVideo();
        }
      } else {
        if (external_jQuery_default()('[data-youtube]').length > -1) {
          // Insert the <script> tag targeting the iframe API
          var tag = document.createElement('script');
          tag.src = "https://www.youtube.com/iframe_api";
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          tag.onload = function () {
            setTimeout(function () {
              setupVideo();
            }, 800);
          };
        }
      }

      function setupVideo() {
        // Get the video ID passed to the data-video attribute
        window.YT.ready(function () {
          external_jQuery_default.a.each(external_jQuery_default()('[data-youtube]'), function (index, elm) {
            var bgVideoID = external_jQuery_default()(elm).data('video');

            if (!window.videoPlayer || window.videoPlayer[bgVideoID] == undefined) {
              // The API will call this function when the video player is ready.
              var onPlayerReady = function onPlayerReady(event) {
                videoPlayer[videoID] = event.target;

                if (typeof external_jQuery_default()(elm).data('aspect-ratio') !== 'undefined') {
                  external_jQuery_default()(elm).fitVids();
                }

                setTimeout(function () {
                  event.target.playVideo();
                }, 0);
                window.videoPlayer = videoPlayer; // if(ytPlayer.g.g.playerVars.autoplay){ 
                //   event.target.playVideo();
                // }
                // Get the duration of the currently playing video

                var videoDuration = event.target.getDuration(); // When the video is playing, compare the total duration
                // To the current passed time if it's below 2 and above 0,
                // Return to the first frame (0) of the video
                // This is needed to avoid the buffering at the end of the video
                // Which displays a black screen + the YouTube loader

                setInterval(function () {
                  var videoCurrentTime = event.target.getCurrentTime();
                  var timeDifference = videoDuration - videoCurrentTime;

                  if (2 > timeDifference > 0) {
                    event.target.seekTo(0);
                  }
                }, 1000);
              };

              // Set the player options
              var autoplay = external_jQuery_default()(elm).data('autoplay');
              var controls = external_jQuery_default()(elm).data('controls');
              var loop = external_jQuery_default()(elm).data('loop');
              var playerOptions = {
                // Autoplay + mute has to be activated (value = 1) if you want to autoplay it everywhere 
                // Chrome/Safari/Mobile
                autoplay: 0,
                mute: 1,
                autohide: 1,
                modestbranding: 1,
                rel: 0,
                showinfo: 0,
                controls: 0,
                disablekb: 1,
                enablejsapi: 1,
                iv_load_policy: 3,
                // For looping video you have to have loop to 1
                // And playlist value equal to your currently playing video
                loop: loop,
                playlist: bgVideoID
              }; // Get the video overlay, to mask it when the video is loaded

              var videoOverlay = external_jQuery_default()(elm).siblings('.video-preload-image');
              var videoID = external_jQuery_default()('.video-player', elm).attr('id'); // This function creates an <iframe> (and YouTube player)
              // after the API code downloads.

              var ytPlayer;
              ytPlayer = new YT.Player(videoID, {
                width: '1280px',
                height: '720px',
                videoId: bgVideoID,
                playerVars: playerOptions,
                events: {
                  'onReady': onPlayerReady
                }
              });
            }
          });
        });
      }
    }
  };
}();

function fadeOut(el) {
  el.style.opacity = 1;

  (function fade() {
    if ((el.style.opacity -= .1) < 0) {
      el.style.display = "none";
    } else {
      requestAnimationFrame(fade);
    }
  })();
}

;

function loadPage() {
  var statusIcon = document.getElementById('status');
  var loadingBackground = document.getElementById('preloader');

  if (statusIcon) {
    fadeOut(statusIcon);
  }

  if (loadingBackground) {
    fadeOut(loadingBackground);
  }

  theme.Site.init();
}

var windowType = window.parent.location;

if (theme.settings.enable_preloader && window.location === window.parent.location && windowType.toString().indexOf("shopifypreview") < 0) {
  loadPage();
} else {
  var bodyElement = document.body;
  bodyElement.classList.remove('animations-enabled');
  loadPage();
} // Get IE or Edge browser version


var version = detectIE();
/**
* detect IE
* returns version of IE or false, if browser is not Internet Explorer
*/

function detectIE() {
  var ua = window.navigator.userAgent; // Test values; Uncomment to check result â€¦
  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');

  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');

  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');

  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  } // other browser


  return false;
}

theme.Maps = function () {
  var apiStatus = null;
  var mapsToLoad = [];
  var errors = {
    addressNoResults: 'No results for that address',
    addressQueryLimit: 'You have exceeded the Google API usage limit. Consider upgrading to a <a href=\"https:\/\/developers.google.com\/maps\/premium\/usage-limits\">Premium Plan<\/a>.',
    addressError: '"Error looking up that address',
    authError: 'There was a problem authenticating your Google Maps account.'
  };
  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]',
    mapType: '[data-type]'
  };
  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  }; // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars

  window.gm_authFailure = function () {
    if (!Shopify.designMode) {
      return;
    }

    external_jQuery_default()(selectors.section).addClass(classes.mapError);
    external_jQuery_default()(selectors.map).remove();
    external_jQuery_default()(selectors.mapOverlay).after('<div class="' + classes.errorMsg + '">' + theme.strings.authError + '</div>');
  };

  function Map(container) {
    this.$container = external_jQuery_default()(container);
    this.$type = this.$container.find(selectors.mapType);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';

        if (typeof window.google === 'undefined') {
          external_jQuery_default.a.getScript('https://maps.googleapis.com/maps/api/js?key=' + this.key).then(function () {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    external_jQuery_default.a.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = external_jQuery_default.a.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');
    geocoder.geocode({
      address: address
    }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });
    return deferred;
  }

  Map.prototype = {
    createMap: function createMap() {
      var $map = this.$map,
          $type = this.$type;
      return geolocate($map).then(function (results) {
        var mapOptions = {
          zoom: $map.data('zoom'),
          center: results[0].geometry.location,
          draggable: false,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          disableDefaultUI: true,
          mapTypeId: $map.data('type')
        };
        var map = this.map = new google.maps.Map($map[0], mapOptions);
        var center = this.center = map.getCenter(); //eslint-disable-next-line no-unused-vars

        var marker = new google.maps.Marker({
          map: map,
          position: map.getCenter()
        });
        google.maps.event.addDomListener(window, 'resize', function () {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(center);
          $map.removeAttr('style');
        });
      }.bind(this)).fail(function () {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = errors.addressNoResults;
            break;

          case 'OVER_QUERY_LIMIT':
            errorMessage = errors.addressQueryLimit;
            break;

          case 'REQUEST_DENIED':
            errorMessage = errors.authError;
            break;

          default:
            errorMessage = errors.addressError;
            break;
        } // Show errors only to merchant in the editor.


        if (Shopify.designMode) {
          $map.parent().addClass(classes.mapError).html('<div class="' + classes.errorMsg + '">' + errorMessage + '</div>');
        }
      });
    },
    onUnload: function onUnload() {
      if (this.$map.length === 0) {
        return;
      }

      google.maps.event.clearListeners(this.map, 'resize');
    }
  };
  return Map;
}();

(function () {
  external_jQuery_default()(document).one('touchstart', function () {
    theme.Helpers.setTouch();
  }); //Misc

  theme.HashScrolling = function () {
    external_jQuery_default()('a[href*="#"]:not([href="#"])').click(function () {
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = external_jQuery_default()(this.hash);
        target = target.length ? target : external_jQuery_default()('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
          external_jQuery_default()('html, body').animate({
            scrollTop: target.offset().top
          }, 1000);
          return false;
        }
      }
    });
  };
})();
/*
theme.Navigation
Container and controller of all navgiation code. This section 
contains very basic initializations, but also has many of the 
selectors used in other sections of the navigation code.
Depends on:
timber
*/


theme.Navigation = function () {
  return {
    /***** Private Properties *****/
    //Selectors used for jQuery targeting
    _selectors: {
      id: '#AccessibleNav',
      dim: '.dim',
      openedNav: '#AccessibleNav .nav-hover',
      closeOnMouseLeave: '.main-menu-dropdown, .site-nav--has-dropdown',
      nextNav: ".site-header .header-icons",
      topLevelMenuItems: '.site-nav--has-dropdown',
      childNavLinks: '.child-site-nav__link',
      subMenuDiv: '.child-div',
      sectionHeaderMenuItems: '.nav-section-header',
      bottomLevelMenuItems: '.grandchild-link .site-nav__link',
      siteHeaderId: '#header',
      mainMenuDropdown: '.main-menu-dropdown',
      singleDropdown: '.single-dropdown',
      // New variables
      navigationList: '.header__nav',
      navItemContainer: '.site-nav__link-container'
    },
    //Classes used to be added/removed/checked against
    _classes: {
      hover: 'nav-hover',
      navBg: 'mega-nav-bg'
    },
    //Event handler for scrolling the window
    _scrollHandler: null,

    /***** Public Methods *****/

    /*
    =function init()
    */
    init: function init() {
      var self = this;
      self._scrollHandler = self.exitNav.bind(self);
      var navUL = external_jQuery_default()('#AccessibleNav').height(),
          navRows = navUL / external_jQuery_default()('#AccessibleNav li').outerHeight(),
          singleDMenu = false,
          multiNav = false;

      if (external_jQuery_default()(self._selectors.singleDropdown).length > 0) {
        var singleDMenu = true;
      }

      if (navRows >= 2) {
        var multiNav = true;
        external_jQuery_default()('#AccessibleNav').addClass('multinav');
      }

      if (!multiNav || singleDMenu) {
        // If single row of link OR single dropdown                       
        external_jQuery_default()(self._selectors.topLevelMenuItems).mouseenter(function () {
          // Close all open elements
          external_jQuery_default()(self._selectors.topLevelMenuItems).removeClass(self._classes.hover);

          if (singleDMenu) {
            var $link = external_jQuery_default()(this),
                $dropdown = external_jQuery_default()('> .child-link', $link),
                screenWidth = external_jQuery_default()(window).width(),
                edge = $link.outerWidth() + $link.offset().left + $dropdown.width(),
                offscreen = edge - screenWidth > $link.outerWidth() * 0.01; // Add navBg to single dropdown link

            external_jQuery_default()(this).addClass(self._classes.navBg);

            if (offscreen) {
              $link.addClass('single-dropdown--reverse');
              $dropdown.css({
                'right': 0,
                'left': 'initial'
              });
            } else {
              $link.removeClass('single-dropdown--reverse');
            } // whenever we hover over a menu item that has a submenu


            external_jQuery_default()('.has-children').on('mouseover', function () {
              var $menuItem = external_jQuery_default()(this),
                  $submenuWrapper = external_jQuery_default()('> .grandchild-link', $menuItem);
              $menuItem.addClass('menu-open'); // grab the menu item's position relative to its positioned parent

              var menuItemPos = $menuItem.position();
              var edge = $menuItem.outerWidth() + $menuItem.offset().left + $submenuWrapper.width();
              var screenWidth = external_jQuery_default()(window).width();
              var offscreen = edge - screenWidth > $menuItem.outerWidth() * 0.01;
              var direction = {
                top: menuItemPos.top,
                left: menuItemPos.left + Math.round($menuItem.outerWidth() * 0.80)
              }; // place the submenu in the correct position relevant to the menu item target.position().left + target.width();

              if (offscreen) {
                direction = {
                  top: menuItemPos.top,
                  left: -Math.abs(menuItemPos.left + Math.round($menuItem.outerWidth()))
                };
                $submenuWrapper.css(direction);
                $submenuWrapper.find('ul').addClass('dropdown-left');
              } else {
                $submenuWrapper.css(direction);
                $submenuWrapper.find('ul').removeClass('dropdown-left');
              }
            });
            external_jQuery_default()('.has-children').on('mouseleave', function () {
              var $menuItem = external_jQuery_default()(this);
              $menuItem.removeClass('menu-open');
            });
          } else {
            // Add navBg to entire header for mega-menu
            external_jQuery_default()(self._selectors.siteHeaderId).addClass(self._classes.navBg);
          }

          external_jQuery_default()(this).addClass(self._classes.hover);
          external_jQuery_default()(self._selectors.dim).show();
          external_jQuery_default()(window).scroll(self._scrollHandler);
        });

        if (!singleDMenu) {
          external_jQuery_default()(self._selectors.topLevelMenuItems).mouseleave(function () {
            setTimeout(function () {
              if (external_jQuery_default()('.main-menu-dropdown:hover').length == 0 && external_jQuery_default()('#AccessibleNav > .site-nav--has-dropdown:hover').length == 0) {
                self.exitNav();
              }
            }, 500);
          });
        }

        if (singleDMenu) {
          // Remove single menu hover and exit nav
          external_jQuery_default()(self._selectors.closeOnMouseLeave).mouseleave(function () {
            external_jQuery_default()(this).removeClass(self._classes.navBg);
            self.exitNav();
          });
        }

        external_jQuery_default()(self._selectors.siteHeaderId).mouseleave(function () {
          if (external_jQuery_default()('main-menu-dropdown:hover').length == 0 && !external_jQuery_default()('#AccessibleNav').hasClass('multinav')) {
            self.exitNav();
          }
        });
      } else {
        external_jQuery_default()(self._selectors.topLevelMenuItems, self._selectors.id, '#AccessibleNav > li').unbind("mouseenter mouseleave");
        external_jQuery_default()(self._selectors.topLevelMenuItems).click(function (e) {
          return false;
        });
        external_jQuery_default()(self._selectors.childNavLinks).click(function (e) {
          e.stopPropagation();
          return true;
        });
        external_jQuery_default()(self._selectors.topLevelMenuItems, self._selectors.id).click(function () {
          self.exitNav();
          external_jQuery_default()(self._selectors.siteHeaderId).addClass(self._classes.navBg);
          external_jQuery_default()(this).addClass(self._classes.hover);
          external_jQuery_default()(self._selectors.dim).show();
          external_jQuery_default()(window).scroll(self._scrollHandler);
        });
        external_jQuery_default()(window).click(function () {
          if (external_jQuery_default()(self._selectors.topLevelMenuItems, self._selectors.id).hasClass(self._classes.hover)) {
            self.exitNav();
          }
        });
      }

      function checkNavigationRows(parentContainer, childElement) {
        return parentContainer.offsetHeight / childElement.offsetHeight;
      }

      external_jQuery_default()(window).resize(function () {
        if (external_jQuery_default()(window).width() > 768) {
          var mainNavigationList = document.querySelector(self._selectors.navigationList);
          var firstMenuItem = mainNavigationList.querySelector(self._selectors.navItemContainer);
          var numberOfRows = checkNavigationRows(mainNavigationList, firstMenuItem);
          var naviRows = checkNavigationRows(mainNavigationList, firstMenuItem),
              singleDMenus = false,
              multiNavi = false;

          if (external_jQuery_default()(self._selectors.singleDropdown).length > 0) {
            singleDMenus = true;
          }

          if (naviRows > 1) {
            multiNavi = true;
            external_jQuery_default()('#AccessibleNav').addClass('multinav');
          } else {
            external_jQuery_default()('#AccessibleNav').removeClass('multinav');
          }

          if (!multiNavi || singleDMenus) {
            if (!multiNavi) {
              external_jQuery_default()('#AccessibleNav > .site-nav--active').mouseenter(function () {
                if (!external_jQuery_default()('#AccessibleNav').hasClass('multinav')) {
                  self.exitNav();
                }
              });
            } // If single row of link OR single dropdown                       


            external_jQuery_default()(self._selectors.topLevelMenuItems).mouseenter(function () {
              // Close all open elements
              external_jQuery_default()(self._selectors.topLevelMenuItems).removeClass(self._classes.hover);

              if (singleDMenus) {
                // Add navBg to single dropdown link
                external_jQuery_default()(this).addClass(self._classes.navBg);
              } else {
                // Add navBg to entire header for mega-menu
                external_jQuery_default()(self._selectors.siteHeaderId).addClass(self._classes.navBg);
              }

              external_jQuery_default()(this).addClass(self._classes.hover);
              external_jQuery_default()(self._selectors.dim).show();
              external_jQuery_default()(window).scroll(self._scrollHandler);
            });

            if (!singleDMenus) {
              external_jQuery_default()(self._selectors.topLevelMenuItems).mouseleave(function () {
                setTimeout(function () {
                  if (external_jQuery_default()('.main-menu-dropdown:hover').length == 0 && external_jQuery_default()('#AccessibleNav > li:hover').length == 0) {
                    self.exitNav();
                  }
                }, 500);
              });
            }

            if (singleDMenus) {
              // Remove single menu hover and exit nav
              external_jQuery_default()(self._selectors.closeOnMouseLeave).mouseleave(function () {
                external_jQuery_default()(this).removeClass(self._classes.navBg);
                self.exitNav();
              });
            }

            external_jQuery_default()(self._selectors.siteHeaderId).mouseleave(function () {
              if (external_jQuery_default()('main-menu-dropdown:hover').length == 0 && !external_jQuery_default()('#AccessibleNav').hasClass('multinav')) {
                self.exitNav();
              }
            });
          } else {
            external_jQuery_default()(self._selectors.topLevelMenuItems, self._selectors.id, '#AccessibleNav > .site-nav--active').unbind("mouseenter mouseleave");
            external_jQuery_default()(self._selectors.topLevelMenuItems).click(function (e) {
              return false;
            });
            external_jQuery_default()(self._selectors.childNavLinks).click(function (e) {
              e.stopPropagation();
              return true;
            });
            external_jQuery_default()(self._selectors.topLevelMenuItems, self._selectors.id).click(function () {
              self.exitNav();
              external_jQuery_default()(self._selectors.siteHeaderId).addClass(self._classes.navBg);
              external_jQuery_default()(this).addClass(self._classes.hover);
              external_jQuery_default()(self._selectors.dim).show();
              external_jQuery_default()(window).scroll(self._scrollHandler);
            });
            external_jQuery_default()(window).click(function () {
              if (external_jQuery_default()(self._selectors.topLevelMenuItems, self._selectors.id).hasClass(self._classes.hover)) {
                self.exitNav();
              }
            });
          }
        }
      }); //Init keyboard accessibility

      this.Keyboard.init();
    },

    /*
    =function displayOrHideSharedElements()
    Displays the shared elements between the nav and search, 
    such as background dims. Hides them if "hide" is true.
    =Params
    (bool) hide: (optional) If true, the shared elements are hidden
    */
    displayOrHideSharedElements: function displayOrHideSharedElements(hide) {
      if (hide) {
        external_jQuery_default()(this._selectors.dim).hide();
        external_jQuery_default()(this._selectors.siteHeaderId).removeClass(this._classes.navBg);
      } else {
        external_jQuery_default()(this._selectors.dim).show();
        external_jQuery_default()(this._selectors.siteHeaderId).addClass(this._classes.navBg);
      }
    },

    /*
    =function exitNav()
    Completely hides all aspects of the nav, essentially closing it.
    */
    exitNav: function exitNav() {
      var $mainNavBar = external_jQuery_default()(this._selectors.id);
      this.displayOrHideSharedElements($mainNavBar.closest('[data-section-id]'), true);
      $mainNavBar.find(this._selectors.topLevelMenuItems).removeClass(this._classes.navBg);
      $mainNavBar.find(this._selectors.topLevelMenuItems).removeClass(this._classes.hover);
      $mainNavBar.find(this._selectors.mainMenuDropdown + ', ' + this._selectors.singleDropdown).css('display', '');
      external_jQuery_default()(window).off('scroll', this._scrollHandler);
    },

    /*
    =function initTimber()
    Some of the theme's functionality relies on timber. This
    function calls the appropriate timber functions to fully
    initialize the navigation. Used by the sections initialization
    code.
    */
    initTimber: function initTimber() {
      timber.cacheSelectors();
      timber.drawersInit();
    },

    /*
    theme.Navigation.Keyboard
    Initiates the controls needed to navigate the main menu.
    */
    Keyboard: {
      /***** "Parent" References *****/
      _selectors: null,
      _classes: null,
      _scrollHandler: null,

      /***** Public Methods *****/

      /*
      =function init()
      */
      init: function init() {
        var self = this; //Init the "parent" references

        self._selectors = theme.Navigation._selectors, self._classes = external_jQuery_default.a.extend(theme.Navigation._classes, {
          subMenuDiv: 'child-div'
        });
        self._scrollHandler = theme.Navigation._scrollHandler; //Close the nav if ESC is pressed

        external_jQuery_default()(document).keyup(function (e) {
          if (e.keyCode === 27) {
            theme.Navigation.exitNav();
            return false;
          }
        }); //Setup the keydown events

        external_jQuery_default()(self._selectors.topLevelMenuItems, self._selectors.id).each(function () {
          var $this = external_jQuery_default()(this); //Keydown event handler for top level menu items

          $this.keydown(function (e) {
            //If the input is one of the arrow keys, react to it
            if (37 <= e.keyCode && e.keyCode <= 40) {
              e.preventDefault();
              var $this = external_jQuery_default()(this);

              switch (e.keyCode) {
                case 38:
                  //Up - Close the nav
                  self._closeMainNav(external_jQuery_default()(this));

                  break;

                case 40:
                  //Down - Open the nav
                  //If the nav is already opened, focus the first available menu item or header
                  if ($this.hasClass(self._classes.hover)) {
                    self._focusFirstAvailableSubMenu($this);
                  } else {
                    self._openMainNav(external_jQuery_default()(this));
                  }

                  break;

                case 37: //Left - Move to the nav on the left

                case 39:
                  //Right - Move to the nav on the right
                  self._openAdjacentNav($this, e.keyCode == 37, $this.hasClass(self._classes.hover));

                  break;
              }
            }
          }); //Keydown event handler for menu section headers

          $this.find(self._selectors.sectionHeaderMenuItems).keydown(function (e) {
            if (37 <= e.keyCode && e.keyCode <= 40) {
              e.preventDefault();
              e.stopPropagation();

              switch (e.keyCode) {
                case 38:
                  //Up - Focus the top level nav for this menu
                  var $topNav = external_jQuery_default()(this).closest(self._selectors.topLevelMenuItems);
                  $topNav.children('a').focus();
                  break;

                case 40:
                  //Down - Go to the first bottom level menu item
                  external_jQuery_default()(this).parent().find(self._selectors.bottomLevelMenuItems + ':first').focus();
                  break;

                case 37: //Left - Focus the menu title to the left

                case 39:
                  //Right - Focus the menu title to the right
                  self._focusNextTitle(external_jQuery_default()(this).parent(), e.keyCode == 37);

                  break;
              }
            }
          });
          $this.find(self._selectors.bottomLevelMenuItems).keydown(function (e) {
            if (37 <= e.keyCode && e.keyCode <= 40) {
              e.preventDefault();
              e.stopPropagation();
              var $this = external_jQuery_default()(this);
              var myIndex = $this.parent().index();

              switch (e.keyCode) {
                case 38: //Up - Focus the menu item above this one

                case 40:
                  //Down - Focus the menu item below this one
                  self._focusSiblingMenuItem($this.parent(), e.keyCode == 38);

                  break;

                case 37: //Left - Focus the menu item to the left of this one

                case 39:
                  //Right - Focus the menu item to the right of this one
                  self._focusAdjacentMenuItem($this.closest(self._selectors.subMenuDiv), e.keyCode == 37, myIndex);

                  break;
              }
            }
          });
        });
      },

      /*
      =function _focusFirstAvailableSubMenu($nav)
      Finds the first focusable item in $nav and focuses it
      =Params
      (jQuery) $nav - The nav container to search in
      */
      _focusFirstAvailableSubMenu: function _focusFirstAvailableSubMenu($nav) {
        var toFocus = $nav.find(this._selectors.sectionHeaderMenuItems + ':first');

        if (toFocus && toFocus.length > 0) {
          toFocus.focus();
        } else {
          $nav.find(this._selectors.bottomLevelMenuItems + ':first').focus();
        }
      },

      /*
      =function _openMainNav($nav, ignoreFocus)
      Opens and displays the $nav passed in
      =Params
      (jQuery) $nav - The nav container to display
      (bool) ignoreFocus - (optional) If true, focuses closest sub menu 
                      item. Otherwise it focuses the top level menu 
                      item.
      */
      _openMainNav: function _openMainNav($nav, ignoreFocus) {
        //Set styles for outside of the nav
        theme.Navigation.displayOrHideSharedElements(); //Open the nav itself

        $nav.find(this._selectors.mainMenuDropdown).show();
        $nav.addClass(this._classes.hover); //Focus the first element

        if (!ignoreFocus) {
          this._focusFirstAvailableSubMenu($nav);
        } else {
          $nav.children('a').focus();
        }

        external_jQuery_default()(window).scroll(this._scrollHandler);
      },

      /*
      =function _closeMainNav($nav)
      Closes the $nav passed in.
      =Params
      (jQuery) $nav - The nav container to close
      */
      _closeMainNav: function _closeMainNav($nav) {
        //Unset styles for outside of the nav
        theme.Navigation.displayOrHideSharedElements($nav.mySection(), true); //Close the nav itself

        $nav.find(this._selectors.mainMenuDropdown).hide();
        $nav.removeClass(this._classes.hover);
        external_jQuery_default()(window).off('scroll', theme.Navigation._scrollHandler);
      },

      /*
      =function _getAdjacentElement($nav, goLeft, selector)
      Get the adjacent element matching the selector of the 
      passed in element $nav.
      =Params
      (jQuery) $nav - The element to get the adjacent of
      (bool) goLeft - If true, get the "previous" element. Otherwise
                get the "next" element
      (string) selector - The element to search for
      */
      _getAdjacentElement: function _getAdjacentElement($nav, goLeft, selector) {
        if (goLeft) {
          return $nav.prev(selector);
        } else {
          return $nav.next(selector);
        }
      },

      /*
      =function _openAdjacentNav($nav, goLeft, ignoreFocus)
      Opens the nav adjacent to the current one
      =Params
      (jQuery) $nav - The currently opened menu nav
      (bool) goLeft - If true, get the "previous" menu nav. 
                Otherwise get the "next" one
      (bool) ignoreFocus - (optional) If true, focuses closest sub menu 
                      item. Otherwise it focuses the top level menu 
                      item.
      */
      _openAdjacentNav: function _openAdjacentNav($nav, goLeft, ignoreFocus) {
        var $adjacent = this._getAdjacentElement($nav, goLeft, this._selectors.topLevelMenuItems);

        if ($adjacent.length > 0) {
          this._closeMainNav($nav);

          this._openMainNav($adjacent, ignoreFocus);
        }
      },

      /*
      =function _focusNextTitle($nav, goLeft)
      Focuses the menu title adjacent to the current one
      =Params
      (jQuery) $nav - The currently focused menu title
      (bool) goLeft - If true, focus the menu title to the left.
                Otherwise focus the one on the right
      */
      _focusNextTitle: function _focusNextTitle($nav, goLeft) {
        var $adjacent = this._getAdjacentElement($nav, goLeft, this._selectors.subMenuDiv);

        if ($adjacent.length > 0) {
          $adjacent.find(this._selectors.sectionHeaderMenuItems).focus();
        } else {
          this._openAdjacentNav($nav.closest(this._selectors.topLevelMenuItems), goLeft);
        }
      },

      /*
      =function _focusSiblingMenuItem($nav, goUp)
      Focuses the menu item above or below one
      =Params
      (jQuery) $nav - The currently focused menu item
      (bool) goUp - If true, focus the menu item above $nav. 
              Otherwise get the one below
      */
      _focusSiblingMenuItem: function _focusSiblingMenuItem($nav, goUp) {
        var $sibling;

        if (goUp) {
          $sibling = $nav.prev();

          if ($sibling.length > 0) {
            $sibling.children('a').focus();
          } else {
            var $closestTitle = $nav.closest(this._selectors.subMenuDiv).children('a');

            if ($closestTitle.length > 0) {
              $closestTitle.focus();
            } else {
              $nav.closest(this._selectors.topLevelMenuItems).children('a').focus();
            }
          }
        } else {
          $sibling = $nav.next();

          if ($sibling.length > 0) {
            $sibling.children('a').focus();
          }
        }
      },

      /*
      =function _performAdjacentMenuItemFocus($adjacentList, index)
      Performs the actual focusing of the adjacement menu element
      =Params
      (jQuery) $adjacentList - The list that contains the menu item to focus
      (int) index - The index to focus in the adjacent list
      */
      _performAdjacentMenuItemFocus: function _performAdjacentMenuItemFocus($adjacentList, index) {
        var $menuItems;

        if ($adjacentList.hasClass(this._classes.subMenuDiv)) {
          $menuItems = $adjacentList.find(this._selectors.bottomLevelMenuItems);
        } else {
          $menuItems = $adjacentList;
        }

        index = $menuItems.length - 1 < index ? $menuItems.length - 1 : index;
        $menuItems.eq(index).focus();
      },

      /*
      =function _focusSiblingMenuItem($nav, goUp)
      Focuses the menu item above or below one
      =Params
      (jQuery) $nav - The currently focused menu item
      (bool) goUp - If true, focus the menu item above $nav. 
              Otherwise get the one below
      */
      _focusAdjacentMenuItem: function _focusAdjacentMenuItem($nav, goLeft, index) {
        var $adjacentList = this._getAdjacentElement($nav, goLeft, this._selectors.subMenuDiv + ',' + this._selectors.bottomLevelMenuItems);

        if ($adjacentList.length > 0) {
          this._performAdjacentMenuItemFocus($adjacentList, index);
        } else {
          this._openAdjacentNav($nav.closest(this._selectors.topLevelMenuItems), goLeft);
          /*if(!$nav.is(':focus')) {
          var $newNav = $(':focus', $nav.closest(this._selectors.id));
          this._performAdjacentMenuItemFocus($newNav, index);
          }*/

        }
      }
    } //END Keyboard

  };
}();
/*
  theme.Search
  Controls the search form's display and submission.    
*/


theme.Search = function () {
  return {
    /***** Private Properties *****/

    /*
      Selectors used for jQuery targeting
    */
    _selectors: {
      searchForm: '.search-bar',
      searchBaseSubmit: '.js-base-search'
    },

    /***** Public Methods *****/

    /*
      =function init(container)
      Initializes the event handlers used by search. 
    */
    init: function init(container) {
      var self = this;
      self.container = container;
    },
    initBaseSearch: function initBaseSearch(container) {
      var $container = external_jQuery_default()(container);
      $container.find(this._selectors.searchBaseSubmit).click(function (e) {
        e.preventDefault();
        var $form = external_jQuery_default()(this).closest('form');
        var searchQuery = $form.find('input[name="q"]').val();
        searchQuery = 'q=' + (searchQuery === '' ? '**' : encodeURIComponent(searchQuery));
        window.location.href = theme.routes.search_url + '?' + searchQuery + "&type=product";
      });
    }
  };
}();
/*
  Functionality pulled from the theme Debut, slightly
  modified for our theme.
*/


theme.SectionManager = function SectionManager() {
  this.constructors = {};
  this.sections = [];

  if (Shopify.designMode) {
    external_jQuery_default()('body').addClass('editor-window');
  }

  external_jQuery_default()(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.SectionManager.prototype = {
  _findSectionIndex: function _findSectionIndex(sectionId) {
    return this.sections.findIndex(function (element) {
      return element.id === parseInt(sectionId);
    });
  },
  _runEventFunction: function _runEventFunction(func, evt) {
    if (func && typeof func === 'function') {
      func(evt);
    }
  },
  _createSection: function _createSection(container, constructor) {
    var $container = external_jQuery_default()(container);
    var type = $container.data('section-type');
    constructor = constructor || this.constructors[type];

    if (!constructor) {
      return;
    }

    var newInstance = new constructor(container);
    newInstance.id = $container.data('section-id');
    this.sections.push(newInstance);
  },
  _onSectionLoad: function _onSectionLoad(evt) {
    var container = external_jQuery_default()('[data-section-id]', evt.target)[0];

    if (container) {
      this._createSection(container);
    }
  },
  _onSectionUnload: function _onSectionUnload(evt) {
    var instanceNdx = this._findSectionIndex(evt.originalEvent.detail.sectionId);

    if (instanceNdx !== -1) {
      this._runEventFunction(this.sections[instanceNdx].onUnload, evt);

      this.sections.splice(instanceNdx, 1);
    }
  },
  _onBlockSelect: function _onBlockSelect(evt) {
    var instanceNdx = this._findSectionIndex(evt.originalEvent.detail.sectionId);

    if (instanceNdx !== -1) {
      this._runEventFunction(this.sections[instanceNdx].onBlockSelect, evt);
    }
  },
  _onBlockDeselect: function _onBlockDeselect(evt) {
    var instanceNdx = this._findSectionIndex(evt.originalEvent.detail.sectionId);

    if (instanceNdx !== -1) {
      this._runEventFunction(this.sections[instanceNdx].onBlockDeselect, evt);
    }
  },
  register: function register(container, type, constructor) {
    if (constructor !== undefined) {
      this.constructors[type] = constructor;

      this._createSection(container, constructor); // $('[data-section-type=' + type + ']').each(function (index, container) {
      //   this._createSection(container, constructor);
      // }.bind(this));

    }
  }
}; //Theme sections

theme.Sections = {};

theme.Sections.Cart = function (container) {
  var CartContainer = container;
  cart["a" /* ThemeCart */].init(CartContainer); // document.body.addEventListener(AjaxCartEvents.eventStrs.updateCartSuccess, function(){
  //   console.log("Cart reloaded")
  //   ThemeCart.init(CartContainer)
  // })
};

theme.Sections.Maps = function (container) {
  theme.Maps();
};

theme.Sections.Footer = function (container) {
  var localeDisclosure = new theme.Disclosure(external_jQuery_default()('[data-disclosure-locale]', container));
  var currencyDisclosure = new theme.Disclosure(external_jQuery_default()('[data-disclosure-currency]', container));
};

theme.Sections.Header = function (container) {
  this.container = container;
  this.headerContainer = this.container.querySelector('.header__wrapper');
  this.logoContainer = this.headerContainer.querySelector('.header__logo');
  this.navDropdownPanels = this.headerContainer.querySelectorAll('.main-menu-dropdown');
  this.headerHeight = this._getElementSizes().headerHeight;
  this.settings = {};
  this.headerHeightChanged = new CustomEvent('loft:NewHeaderHeight');
  this.init();
};

theme.Sections.Header.prototype = {
  init: function init() {
    this._getWindowSize();

    this._addEventListeners();

    this._resizeLogo();

    this._initNav();
  },
  _getWindowSize: function _getWindowSize() {
    return this.container.size = window.innerWidth;
  },
  _addEventListeners: function _addEventListeners() {
    events_default.a.on('resize', '*', function () {
      this._compareSizes();

      this._resizeLogo();
    }.bind(this));
    events_default.a.on('loft:NewHeaderHeight', '*', function () {
      this._recordNewHeaderHeight(this._getElementSizes().headerHeight, this._setDropdownMenuTopLocation());

      this._setMaxMenuHeight(this.headerContainer);
    }.bind(this));
    events_default.a.on(cart_events["a" /* AjaxCartEvents */].eventStrs.addToCartSuccess, "*", function (event) {
      this._getCartData();
    }.bind(this));
  },
  _getCartData: function _getCartData() {
    var cartItemCountContainer = document.getElementById('cart-svg-count');
    var oldItemCount = parseInt(cartItemCountContainer.textContent);
    fetch('/cart.js').then(function (response) {
      return response.json();
    }).then(function (cartResponse) {
      var cartItemCountContainer = document.getElementById('cart-svg-count');
      var oldItemCount = parseInt(cartItemCountContainer.textContent);

      if (cartResponse.item_count > oldItemCount) {
        cartItemCountContainer.style.display = "block";
        cartItemCountContainer.textContent = cartResponse.item_count;
      }
    });
  },
  _getElementSizes: function _getElementSizes() {
    var headerHeight = this.headerContainer.getBoundingClientRect().height;
    var headerHeightVariable = headerHeight + "px";
    document.documentElement.style.setProperty('--header_height', headerHeightVariable);
    return {
      headerHeight: headerHeight,
      logoWidth: this.logoContainer.offsetWidth
    };
  },
  _resizeLogo: function _resizeLogo() {
    var logoElement = this.headerContainer.querySelector('.header__logo-text');

    if (logoElement === null) {
      return;
    }

    this.logoContainer.style.width = '';

    var sizeData = this._getElementSizes();

    var logoText = fitty_default()('.header__logo-text', {
      maxSize: 42,
      multiLine: false
    });
    this.logoText = logoText[0].element;
    this.logoText.addEventListener('fit', function (e) {
      this._compareSizes();
    }.bind(this));
    logoText[0].fit();
    logoElement.style.visibility = "visible";
  },
  _recordNewHeaderHeight: function _recordNewHeaderHeight(height, callback) {
    this.headerHeight = height;

    if (callback) {
      callback(this.navDropdownPanels);
    }
  },
  _compareSizes: function _compareSizes() {
    var originalHeight = this.headerHeight;

    var newHeight = this._getElementSizes().headerHeight;

    if (originalHeight !== newHeight) {
      window.dispatchEvent(this.headerHeightChanged);
    }
  },
  _initNav: function _initNav() {
    if (this.container.size > 768) {
      this._setDropdownMenuTopLocation(this.navDropdownPanels);

      this._setMaxMenuHeight(this.headerContainer);

      theme.Navigation.initTimber(this.container);
      theme.Navigation.init(this.container);
    }
  },
  _setDropdownMenuTopLocation: function _setDropdownMenuTopLocation(menus) {
    var menusToCheck = menus || this.navDropdownPanels;

    if (menusToCheck === undefined) {
      return;
    }

    var sizeData = this._getElementSizes();

    var offsetHeightBy = this._calculateMenuOffset(sizeData);

    menusToCheck.forEach(function (item) {
      item.style.top = offsetHeightBy;
    });
  },
  _setMaxMenuHeight: function _setMaxMenuHeight(headerElement) {
    var headerHeight = headerElement.offsetHeight;
    var maxHeight = (window.innerHeight - headerHeight) * 0.8;
    this.navDropdownPanels.forEach(function (menu) {
      menu.style.maxHeight = maxHeight + 'px';
    });
  },
  _calculateMenuOffset: function _calculateMenuOffset(sizes) {
    return sizes.headerHeight + 'px';
  }
};

theme.Sections.Announcement = function (container) {
  this.container = container;
  var localeDisclosure = new theme.Disclosure(external_jQuery_default()('[data-disclosure-locale]', this.container));
  var currencyDisclosure = new theme.Disclosure(external_jQuery_default()('[data-disclosure-currency]', this.container));
  var sliderEnabled = this.checkBlockCount(container.getAttribute('data-block-count'));

  if (sliderEnabled) {
    var sliderAutoplay = this.checkAutoplay(container.getAttribute('data-autoplay'));

    if (sliderAutoplay) {
      this.watchForScroll(this.container);
    }

    this.slider = new flickity_default.a('.swiper-wrapper', {
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 75,
        y2: 35,
        x3: 40
      },
      groupCells: "100%",
      prevNextButtons: true,
      pageDots: false,
      adaptiveHeight: true,
      autoPlay: sliderAutoplay
    });
  }

  if (window.innerWidth < 769) {
    var crossborderForm = document.getElementById('localization_form');
    var mobileMenuCrossborderForm = document.querySelector('.mobile__nav-crossborder');

    if (crossborderForm == null) {
      return;
    }

    if (mobileMenuCrossborderForm !== null) {
      mobileMenuCrossborderForm.appendChild(crossborderForm);
    }
  }
};

theme.Sections.Announcement.prototype = {
  checkBlockCount: function checkBlockCount(shopifyValue) {
    var htmlValue = parseInt(shopifyValue);

    if (htmlValue > 1) {
      return true;
    }

    return false;
  },
  checkAutoplay: function checkAutoplay(shopifyValue) {
    if (shopifyValue === "false") {
      return false;
    } else {
      return parseInt(shopifyValue);
    }
  },
  checkCurrentAutoplayState: function checkCurrentAutoplayState() {
    return this.autoplayState;
  },
  toggleAutoplayState: function toggleAutoplayState(desiredState) {
    var currentState = this.checkCurrentAutoplayState();

    if (currentState === null || currentState !== desiredState) {
      this.autoplayState = desiredState;
    }
  },
  pauseAutoplay: function pauseAutoplay() {
    this.toggleAutoplayState("paused");
    this.slider.pausePlayer();
  },
  resumeAutoplay: function resumeAutoplay() {
    this.toggleAutoplayState("playing");
    this.slider.unpausePlayer();
  },
  checkIfElementIsInViewport: function checkIfElementIsInViewport(elementToCheck) {
    var isOut = isOutOfViewport(elementToCheck);

    if (isOut.any) {
      this.pauseAutoplay();
    } else {
      this.resumeAutoplay();
    }
  },
  watchForScroll: function watchForScroll(elementToWatch) {
    var lastKnownScrollPosition = 0;
    var ticking = false;
    events_default.a.on('scroll', '*', function () {
      lastKnownScrollPosition = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(function () {
          this.checkIfElementIsInViewport(elementToWatch);
          ticking = false;
        }.bind(this));
        ticking = true;
      }
    }.bind(this));
  }
};

theme.Sections.FeaturedProduct = function (container) {
  var $mainContainer = external_jQuery_default()(container);
  $mainContainer.find('.desktop-featured-product').each(function () {
    var $container = external_jQuery_default()(this);
    product_section["a" /* products */].init($container); // productVariants.init($container, true);
  });
};

theme.Sections.SearchTemplate = function (container) {
  theme.Search.initBaseSearch(container);
};

theme.Sections.Video = function (container) {
  var _this = this;

  var selectors = {
    videoWrapper: '[data-loft-video-wrapper]',
    playButton: '[data-video-play]',
    billboardImage: '[data-video-billboard]',
    videoSrc: 'data-video-src',
    videoElement: 'iframe'
  };
  this.container = container;
  this.sectionId = container.getAttribute('data-section-id');
  this.videoWrapper = container.querySelector(selectors.videoWrapper);
  this.billboard = container.querySelector(selectors.billboardImage);
  this.playButton = container.querySelector(selectors.playButton);
  this.videoSrc = this.videoWrapper.getAttribute(selectors.videoSrc);
  this.videoElement = this.videoWrapper.querySelector('iframe') || this.videoWrapper.querySelector('video');
  this.sectionVideo = this.container.querySelector('iframe');
  this.sectionVideoElement = '';

  function setupLoadEvent(element, section) {
    if (section.billboard !== null && section.billboard !== undefined) {
      element.play();
    }
  }

  if (this.billboard !== null && this.billboard !== undefined) {
    events_default.a.once('click', selectors.videoWrapper, function () {
      this.videoElement.src = this.videoSrc;
      LoftSiteVideo.init(this.container, this.sectionId);
      this.billboard.classList.add('animate__animated', 'animate__zoomOut');
      this.playButton.classList.add('animate__animated', 'animate__faster', 'animate__fadeOut');
    }.bind(this));
    this.billboard.addEventListener('animationend', function () {
      _this.billboard.style.display = 'none';
      _this.playButton.style.display = 'none';
    });
  } else {
    this.videoElement.src = this.videoSrc;
    this.videoElement.muted = true;
    LoftSiteVideo.init(this.container, this.sectionId);
  }

  var videoWrapper = container.querySelector('.video-section__wrapper');
  var videoElement = container.querySelector('[data-id]');
  var sectionId = container.getAttribute('data-section-id');

  function checkLoadStatus(element) {
    if (element.ready === true) {
      return true;
    }

    return false;
  }

  events_default.a.on('loft:VideoPlayer__Loaded', '*', function (event) {
    var self = this;
    this.sectionVideoElement = event.detail.player;
    var player = event.detail.player;
    setupLoadEvent(player, self);
  }.bind(this));
};

theme.Sections.Availability = function (container) {// let variant_id = container.getAttribute('data-variant-id');
  // fetch('/variants/' + variant_id + '/?section_id=product__pickup-availability')
  //   .then(response => response.text())
  //   .then(text => {
  //     const container = document.querySelector('[data-store-availability-container]');
  //     const pickupAvailabilityHTML = new DOMParser()
  //       .parseFromString(text, 'text/html')
  //       .querySelector('.shopify-section');
  //     container.appendChild(pickupAvailabilityHTML);
  //   })
  //   .catch(e => {
  //   });
};

function buildSections() {
  var sections = new theme.SectionManager();
  var sectionsPresent = document.querySelectorAll('[data-section-type]');
  var uniqueSections = [];
  sectionsPresent.forEach(function (item) {
    var sectionContainer = item;
    var sectionType = sectionContainer.getAttribute('data-section-type');
    var sectionData = {
      container: sectionContainer,
      type: sectionType
    };
    uniqueSections.push(sectionData);
  });

  function initSections(data) {
    var sectionData = data;
    var sectionConstructorName = sectionData.type.replace("-", '_');
    var sectionPrototypes = {
      announcement: theme.Sections.Announcement,
      header: theme.Sections.Header,
      // product: theme.Sections.ProductTemplate,
      featured_product: theme.Sections.FeaturedProduct,
      cart: theme.Sections.Cart,
      map: theme.Maps,
      collection: theme.Filters,
      search_template: theme.Sections.SearchTemplate,
      video: theme.Sections.Video,
      footer: theme.Sections.Footer,
      availability: theme.Sections.Availability
    };
    sections.register(sectionData.container, sectionData.type, sectionPrototypes[sectionConstructorName]);
  }

  ;
  uniqueSections.forEach(function (section) {
    initSections(section);
  });
}

;
window.addEventListener("load", function (event) {
  buildSections();
});
micromodal_es["a" /* default */].init({
  onShow: function onShow(modal) {
    window.dispatchEvent(new CustomEvent("loft:QuickviewModal__Opened", {
      detail: {
        modal_id: modal.id
      }
    }));
  },
  // [1]
  onClose: function onClose(modal) {
    document.body.dispatchEvent(new CustomEvent("loft:QuickviewModal__Closed", {
      detail: {
        modal: modal,
        modal_id: modal.id,
        product_id: modal.getAttribute("data-product-id")
      }
    }));
  },
  openClass: 'is-open',
  // [5]
  disableScroll: true,
  // [6]
  disableFocus: false,
  // [7]
  awaitOpenAnimation: true,
  // [8]
  awaitCloseAnimation: true,
  // [9]
  debugMode: true // [10]

});
// CONCATENATED MODULE: ./src/scripts/main.js


/***/ })

/******/ });